<div class="lang-icon">
  <ppb-lang-select [loginPage]="true"
  ></ppb-lang-select>
</div>
<div class="start-cont"
     style="background-image: url('./assets/ppb_bg.jpg')"
     fxLayout="column"
     fxLayoutAlign="space-between stretch">
  <div class="start-tile-cont">
    <div class="start-tile" [ngClass]="'start-tile--' + width">
      <div class="logo-cont">
        <div fxLayout="row"
             fxLayoutAlign="start center">
          <a href="/">
            <div class="logo" style="background-image: url('./assets/logo.png')"></div>
          </a>
        </div>
      </div>
      <div fxLayout="row"
           fxLayoutAlign="space-between stretch">
        <div class="o-project-title o-project-title--small"
             i18n="@@shared.project-title"
        >Portal Partnera Biznesowego</div>
      </div>
      <div *ngIf="showUserIcon" class="icon-cont">
        <psei-icon name="user"
                   [size]="'L'"></psei-icon>
      </div>
      <ng-content></ng-content>
      <div fxLayout="row"
           fxLayoutAlign="start center">
        <div class="links-bottom-cont" [ngClass]="'start-tile--' + width">
          <div fxLayout="row"
               fxLayoutAlign="space-between start">
            <a href="{{configuration.agreements.rulesUrl}}"
               target="_blank"
               i18n="@@common.statute"
            >Regulamin Portalu Partnera Biznesowego</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
